/**
 *  Keywords getters module file
**/

import { KEYWORD_LEVELS } from '@/api/googleAdsService'
import { GETTERS } from './constants'

export const getters = {
  [GETTERS.GET_SELECTED_ITEMS] (state) {
    const ids = Object.keys(state.selectedMap)
      .filter(key => state.selectedMap[key])
      .map(key => key.replace(`${KEYWORD_LEVELS[3]}-`, ''))

    return ids
    // const children = Object.values(state.childrenMap).flat()
    // const result = new Map()
    // for (const c of children) {
    //   const idIsPresent = result.has(c.id)
    //   const idIsWanted = ids.indexOf(c.id) !== -1
    //   if (c.level === KEYWORD_LEVELS[2] && !idIsPresent && idIsWanted) {
    //     result.set(c.id, c)
    //   }
    // }

    // return Array.from(result.values())
  }
}
